import React from 'react'
import Mus from './Mus'
import Mus2 from './Mus2'
import Mus3 from './Mus3'
import Mus4 from './Mus4'
import Mus5 from './Mus5'
import Mus6 from './Mus6'
import Mus7 from './Mus7'
function Music() {
  return(
    <div>
      <Mus/>
      <Mus2/>
      <Mus3/>
      <Mus4/>
      <Mus5/>
      <Mus6/>
      <Mus7/>
    </div>
  )
}

export default Music
